import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="gallery"
export default class extends Controller {
  static targets = [
    "thumbnail",
    "lightbox",
    "fullImage",
    "galleryOverview",
    "currentIndex",
    "totalImages",
  ];

  connect() {
    this.currentIndex = 0;
    this.boundKeyHandler = this.handleKeyPress.bind(this);
  }

  openLightbox(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.index);
    this.updateFullImage();
    this.updateCounter();
    this.lightboxTarget.classList.remove("hidden");
    this.lightboxTarget.classList.add("flex");
    document.addEventListener("keydown", this.boundKeyHandler);
  }

  closeLightbox() {
    this.lightboxTarget.classList.add("hidden");
    this.lightboxTarget.classList.remove("flex");
    document.removeEventListener("keydown", this.boundKeyHandler);
  }

  // Opens the gallery overview modal showing all images in a grid
  openGalleryOverview() {
    this.galleryOverviewTarget.classList.remove("hidden");
    this.galleryOverviewTarget.classList.add("flex");
    document.addEventListener("keydown", this.boundKeyHandler);
  }

  // Closes the gallery overview modal
  closeGalleryOverview() {
    this.galleryOverviewTarget.classList.add("hidden");
    this.galleryOverviewTarget.classList.remove("flex");
    document.removeEventListener("keydown", this.boundKeyHandler);
  }

  // Opens lightbox from the gallery overview and shows the selected image
  openLightboxFromOverview(event) {
    const index = parseInt(event.currentTarget.dataset.index);
    this.closeGalleryOverview();
    this.currentIndex = index;
    this.updateFullImage();
    this.updateCounter();
    this.lightboxTarget.classList.remove("hidden");
    this.lightboxTarget.classList.add("flex");
    document.addEventListener("keydown", this.boundKeyHandler);
  }

  previousImage() {
    this.currentIndex =
      (this.currentIndex - 1 + this.thumbnailTargets.length) %
      this.thumbnailTargets.length;
    this.updateFullImage();
    this.updateCounter();
  }

  nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.thumbnailTargets.length;
    this.updateFullImage();
    this.updateCounter();
  }

  updateFullImage() {
    const currentImage = this.thumbnailTargets[this.currentIndex];
    this.fullImageTarget.src = currentImage.src;
    this.fullImageTarget.alt = currentImage.alt;
  }

  // Updates the image counter in the lightbox
  updateCounter() {
    if (this.hasCurrentIndexTarget && this.hasTotalImagesTarget) {
      this.currentIndexTarget.textContent = this.currentIndex + 1;
      this.totalImagesTarget.textContent = this.thumbnailTargets.length;
    }
  }

  handleKeyPress(event) {
    switch (event.key) {
      case "Escape":
        if (!this.lightboxTarget.classList.contains("hidden")) {
          this.closeLightbox();
        } else if (!this.galleryOverviewTarget.classList.contains("hidden")) {
          this.closeGalleryOverview();
        }
        break;
      case "ArrowLeft":
        if (!this.lightboxTarget.classList.contains("hidden")) {
          this.previousImage();
        }
        break;
      case "ArrowRight":
        if (!this.lightboxTarget.classList.contains("hidden")) {
          this.nextImage();
        }
        break;
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeyHandler);
  }
}
